export default __webpack_public_path__ + "locales/es/JavascriptSdk.json?hash=25d67708fe86f659793838dc65decd91";